import PropTypes from 'prop-types'
import React from 'react'
import './styles.css'

function CourseListPlaceholder({ title }) {
  return (
    <div className="course-list-placeholder tutorials wrapper" role="presentation">
      <h2 className="tutorials__title">{title}</h2>
      <div className="list">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={`course-${i}`}
            className="course-placeholder tutorial"
          >
            <div className="course-placeholder__header" />
            <div className="course-placeholder__teacher" />
            <div className="course-placeholder__title-1" />
            <div className="course-placeholder__title-2" />
          </div>
        ))}
      </div>
      <div className="more-btn-placeholder" />
    </div>
  )
}

CourseListPlaceholder.propTypes = {
  title: PropTypes.string.isRequired
}

export default CourseListPlaceholder
